import request from "@/utils/request";

// 获取城市列表
export function getCityList() {
    return request({
        url: '/open/city/list',
        method: "get"
    });
}

// 获取区域列表
export function getAreaList() {
    return request({
        url: '/open/area/list',
        method: "get"
    });
}